var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4348 0H12.0585C11.7867 0 11.5258 0.108147 11.3335 0.300407L4.74377 6.89014C4.55151 7.08241 4.44336 7.34329 4.44336 7.61513V31.778C4.44336 33.5546 5.88879 35 7.66533 35H27.4348C29.2063 35 30.6568 33.5677 30.6568 31.778V3.22197C30.6568 1.4505 29.2247 0 27.4348 0ZM12.1314 2.40246V6.51684C12.1314 7.16278 11.6061 7.68803 10.9602 7.68803H6.84582L12.1314 2.40246ZM28.606 31.778C28.606 32.416 28.0904 32.9492 27.4348 32.9492H7.66533C7.01965 32.9492 6.49414 32.4237 6.49414 31.778V9.73907H10.9602C12.7367 9.73907 14.1822 8.29365 14.1822 6.51711V2.05078H27.4348C28.073 2.05078 28.606 2.56668 28.606 3.22197V31.778Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 9H20V10H24V9Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13H15V14H24V13Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13H11V14H14V13Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17H11V18H24V17Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 25H11V26H24V25Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21H11V22H19V21Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21H20V22H24V21Z",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 24.5,
    r: 6.5,
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 24.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4141,
    y: 23.4141,
    width: 4,
    height: 2,
    transform: "rotate(45 26.4141 23.4141)",
    fill: "#D49B00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4141,
    y: 26.2422,
    width: 6,
    height: 2,
    transform: "rotate(-45 26.4141 26.2422)",
    fill: "#D49B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalDocuments);
export default __webpack_public_path__ + "static/media/legal-documents.dc869f372788c100b583aa6b8d81c005.svg";
export { ForwardRef as ReactComponent };